/* Style refonte de la fiche produit : récapitulatif « Maillot / Personnalisation / Total »
   posé juste au-dessus de la quantité et du bouton d'ajout (assets/produit-refonte.js).

   Configuration : <script type="application/json" id="ProduitRefonte-<section>"> écrit par
   sections/main-product.liquid (prix des variantes en centimes, dans la devise affichée).
   Le montant de la personnalisation vient du volet de flocage (snippets/elite-flocage.liquid),
   qui publie l'événement « ef:total » à chaque recalcul : pas de volet (produit sans option
   APO), pas de récapitulatif. Rien ici ne touche au formulaire ni aux champs d'APO. */
(function () {
  if (window.__produitRefonte) return;
  window.__produitRefonte = true;

  var DICT = {
    fr: { maillot: 'Maillot', article: 'Article', perso: 'Personnalisation', total: 'Total' },
    en: { maillot: 'Jersey', article: 'Item', perso: 'Customisation', total: 'Total' },
    es: { maillot: 'Camiseta', article: 'Artículo', perso: 'Personalización', total: 'Total' },
    de: { maillot: 'Trikot', article: 'Artikel', perso: 'Personalisierung', total: 'Gesamt' },
    it: { maillot: 'Maglia', article: 'Articolo', perso: 'Personalizzazione', total: 'Totale' },
    pt: { maillot: 'Camisola', article: 'Artigo', perso: 'Personalização', total: 'Total' },
    sv: { maillot: 'Tröja', article: 'Artikel', perso: 'Personalisering', total: 'Totalt' }
  };

  function start(cfgEl) {
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    if (!cfg.recap) return;
    var T = DICT[cfg.lang] || DICT.fr;
    var root = document.getElementById('MainProduct-' + cfg.section);
    if (!root) return;

    var recap = null;
    var last = null; /* dernier détail reçu du volet */

    function fallbackMoney(n) {
      var cur = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'fr', { style: 'currency', currency: cur || 'EUR' }).format(n);
      } catch (e) {
        return n.toFixed(2).replace('.', ',') + ' €';
      }
    }

    function variantPrice() {
      var input = root.querySelector('#product-form-' + cfg.section + ' input[name="id"]') ||
        document.querySelector('#product-form-' + cfg.section + ' input[name="id"]');
      var id = input && input.value;
      var cents = id && cfg.variants[id];
      if (typeof cents !== 'number') cents = cfg.variants[cfg.current];
      return typeof cents === 'number' ? cents / 100 : null;
    }

    function place() {
      var qWrap = root.querySelector('.product-form__quantity-and-btn');
      if (!qWrap || !qWrap.parentNode) return false;
      var anchor = qWrap;
      while (anchor.previousElementSibling && anchor.previousElementSibling.classList.contains('ef-qty')) {
        anchor = anchor.previousElementSibling;
      }
      if (recap.parentNode === anchor.parentNode && recap.nextElementSibling === anchor) return true;
      anchor.parentNode.insertBefore(recap, anchor);
      return true;
    }

    function build() {
      recap = document.createElement('div');
      recap.className = 'pr-recap';
      recap.setAttribute('aria-live', 'polite');
      recap.innerHTML =
        '<div class="pr-recap__row"><span class="pr-recap__lab-item"></span><span class="pr-recap__item"></span></div>' +
        '<div class="pr-recap__row"><span class="pr-recap__lab-perso"></span><span class="pr-recap__perso"></span></div>' +
        '<div class="pr-recap__row pr-recap__row--total"><span><span class="pr-recap__lab-total"></span><span class="pr-recap__qty"></span></span><span class="pr-recap__total"></span></div>';
      recap.querySelector('.pr-recap__lab-item').textContent = cfg.maillot ? T.maillot : T.article;
      recap.querySelector('.pr-recap__lab-perso').textContent = T.perso;
      recap.querySelector('.pr-recap__lab-total').textContent = T.total;
    }

    function render() {
      if (!last) return;
      var item = variantPrice();
      if (item === null) return;
      if (!recap) build();
      if (!place()) return;
      var fmt = typeof last.money === 'function' ? last.money : fallbackMoney;
      var perso = Math.max(0, Number(last.total) || 0);
      var qty = Math.max(1, parseInt(last.qty, 10) || 1);
      recap.querySelector('.pr-recap__item').textContent = fmt(item);
      recap.querySelector('.pr-recap__perso').textContent = (perso > 0 ? '+' : '') + fmt(perso);
      recap.querySelector('.pr-recap__qty').textContent = qty > 1 ? '× ' + qty : '';
      recap.querySelector('.pr-recap__total').textContent = fmt((item + perso) * qty);
      recap.classList.toggle('has-perso', perso > 0);
    }

    document.addEventListener('ef:total', function (e) {
      last = e.detail || {};
      render();
    });

    /* Changement de taille ou de quantité : le thème réécrit l'identifiant de variante
       un peu après l'événement, d'où les deux relectures. */
    function later() {
      render();
      setTimeout(render, 80);
      setTimeout(render, 450);
    }
    document.addEventListener('change', later, true);
    document.addEventListener('variant:change', later);

    /* Le volet est parfois monté avant ce script (APO rapide, script différé) :
       on lui demande de republier son total. */
    document.dispatchEvent(new CustomEvent('ef:ask'));
  }

  /* « Voir les … avis » sous le titre : défilement doux jusqu'au bloc d'avis,
     arrêté sous l'en-tête collant au lieu de passer dessous. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.produit-refonte .rating-stars a[href^="#"]');
    if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var hash = a.getAttribute('href');
    var cible = null;
    try { cible = document.querySelector(hash); } catch (err) { return; }
    if (!cible) return;
    e.preventDefault();
    var haut = 0;
    var entete = document.querySelector('sticky-header, .shopify-section-header-sticky, .section-header');
    if (entete) {
      var pos = getComputedStyle(entete).position;
      var r = entete.getBoundingClientRect();
      if ((pos === 'sticky' || pos === 'fixed') && r.bottom > 0) haut = r.height;
    }
    var reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: cible.getBoundingClientRect().top + window.scrollY - haut - 16, behavior: reduit ? 'auto' : 'smooth' });
    if (history.replaceState) history.replaceState(null, '', hash);
  });

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('script[id^="ProduitRefonte-"]'), start);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
